import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../store/actions/auth";
import AlertBox from "./AlertBox";

const Header = ({ auth: { user }, logout }) => {
  const [activeProfile, setActiveProfile] = useState(false);
  return (
    <div>
      <div id="layout-wrapper">
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              {/* LOGO */}
              <div className="navbar-brand-box">
                <Link to="/dashboard" className="logo logo-dark">
                  <span className="logo-sm">
                    <img
                      src="https://dermapuritys.com/assets/images/logo.png"
                      alt="Fitlook "
                      height={45}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="https://dermapuritys.com/assets/images/logo.png"
                      alt="Fitlook"
                      height={45}
                    />{" "}
                  </span>
                </Link>
                <Link to="/dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src="https://dermapuritys.com/assets/images/logo.png"
                      alt="Fitlook"
                      height={45}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="https://dermapuritys.com/assets/images/logo.png"
                      alt="Fitlook"
                      height={45}
                    />{" "}
                  </span>
                </Link>
              </div>
              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light"
                data-bs-toggle="collapse"
                data-bs-target="#topnav-menu-content"
              >
                <i className="fa fa-fw fa-bars" />
              </button>
              {/* App Search*/}
            </div>
            <div className="d-flex">
              <div
                className="dropdown d-inline-block"
                onMouseEnter={() => setActiveProfile(!activeProfile)}
                onMouseLeave={() => setActiveProfile(!activeProfile)}
              >
                <button
                  type="button"
                  className="btn header-item"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    className="rounded-circle header-profile-user"
                    src="https://dermapuritys.com/assets/images/logo.png"
                    alt="Header Avatar"
                  />
                  <span className="d-none d-xl-inline-block ms-1 fw-medium">
                    {user.name}
                  </span>
                  <i className="fa fa-angle-down d-none d-xl-inline-block" />
                </button>
                <div
                  className={
                    activeProfile
                      ? "dropdown-menu dropdown-menu-end show"
                      : "dropdown-menu dropdown-menu-end"
                  }
                >
                  <Link className="dropdown-item" to="/profile">
                    <i className="fa fa-user font-size-16 align-middle me-1" />{" "}
                    Profile
                  </Link>

                  <div className="dropdown-divider" />
                  <button
                    style={{ cursor: "pointer" }}
                    className="dropdown-item"
                    onClick={() => logout()}
                  >
                    <i className="fa fa-lock font-size-16 align-middle me-1" />{" "}
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="topnav">
          <div className="container-fluid">
            <nav className="navbar navbar-light navbar-expand-lg topnav-menu">
              <div
                className="collapse navbar-collapse"
                id="topnav-menu-content"
              >
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/dashboard"
                      id="topnav-dashboard"
                      role="button"
                    >
                      <i data-feather="home" />
                      <span data-key="t-dashboards">Dashboard</span>
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <div
                      className="nav-link dropdown-toggle arrow-none"
                      href="#"
                      id="topnav-pages"
                      role="button"
                    >
                      <i data-feather="grid" />
                      <span data-key="t-apps">Blogs</span>{" "}
                      <div className="arrow-down" />
                    </div>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="topnav-pages"
                    >
                      <Link
                        to="/blogs"
                        className="dropdown-item"
                        data-key="t-calendar"
                      >
                        All Blogs
                      </Link>
                      <Link
                        to="/blogs/add"
                        className="dropdown-item"
                        data-key="t-chat"
                      >
                        Add Blogs
                      </Link>
                    </div>
                  </li>
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/feedbacks"
                      id="topnav-dashboard"
                      role="button"
                    >
                      <i data-feather="home" />
                      <span data-key="t-dashboards">Feedbacks</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>

        <div className="main-content" id="miniaresult" />
      </div>
      <AlertBox />
    </div>
  );
};

const mapStateToProps = (state) => ({ auth: state.auth });

const mapDispatchToProps = { logout };

export default connect(mapStateToProps, mapDispatchToProps)(Header);
